import React, { Component } from 'react';
import { Link } from 'react-router';

class Footer extends Component {
  render () {
    let year = new Date().getFullYear();
    return (
      <footer>
        <div>
          <h6>Berwickshire NATS- {year}</h6>
          { this.props.user ? null : <Link to="/admin" className="login-link" >Login</Link> }
        </div>
      </footer>
    )
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Layout/Footer.js
 **/